module.exports = __webpack_public_path__ + "img/green.6f7e6e5f.png";